import ViewComponent from './ViewComponent';

export default ViewComponent;
